import MyAccountSettings from "./settings"

export { Consumer, Provider, MyAccountSettingsContext } from "./settings.context"

export default MyAccountSettings
